export default async function UpdateLandOwnedBy(sendForm) {
    let url = window.RealestateService+  `/api/Land/UpdateLandOwnedBy`
    let head = {
        'Content-Type': 'application/json',
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"POST",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}